import GUI from 'lil-gui';

const STORAGE_PREFIX = 'iedlabs-devpanel';

let root: GUI | null = null;
let visible = true;
let toggleAttached = false;

function attachToggle(): void {
  if (toggleAttached) return;
  toggleAttached = true;
  window.addEventListener('keydown', e => {
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    if (e.key !== 'g' && e.key !== 'G') return;
    const t = e.target as HTMLElement | null;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
    visible = !visible;
    if (root) (visible ? root.show() : root.hide());
  });
}

export function getDevPanel(): GUI | null {
  if (!import.meta.env.DEV) return null;
  if (!root) {
    root = new GUI({ title: 'Dev Controls', width: 280 });
    attachToggle();
  }
  return root;
}

function clearAllPanelState(): void {
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const k = localStorage.key(i);
    if (k?.startsWith(STORAGE_PREFIX)) localStorage.removeItem(k);
  }
}

/**
 * `scope` partitions saved state so tuning one quality tier can't load over
 * another's. Without it, switching tiers restores the previous tier's values on
 * top of the new tier's defaults, which then get exported as if they were authored.
 */
export function persistDevPanel(scope = 'default'): void {
  if (!root) return;

  const key = `${STORAGE_PREFIX}-${scope}`;
  const saved = localStorage.getItem(key);
  if (saved) {
    try {
      root.load(JSON.parse(saved) as Parameters<GUI['load']>[0]);
    } catch {
      localStorage.removeItem(key);
    }
  }

  // Save on every completed interaction (not on every drag tick)
  root.onFinishChange(() => {
    localStorage.setItem(key, JSON.stringify(root!.save()));
  });

  root.add({ reset: () => { clearAllPanelState(); location.reload(); } }, 'reset')
    .name('↺ Reset to defaults');
}

export function destroyDevPanel(): void {
  root?.destroy();
  root = null;
}
